import Request from '@/utils/request';

function toMesoWestTime(time) {
  return time.setZone('utc').toFormat('yLLddHHmm');
}

export default class TimeSeries {

  constructor({ range, vars, stids }) {
    this.range = range;
    this.vars = vars;
    this.stids = stids;
  }

  getTimeSeries() {
    const params = {
      vars: this.vars,
      stids: this.stids,
      start: toMesoWestTime(this.range.start),
      end: toMesoWestTime(this.range.end),
    };
    return Request.get('/stations/timeseries', {
      params,
    });
  }

  getStats() {
    const subtract = this.range.numOfDays < 1 ? 1 : 0;
    const params = {
      type: 'all',
      vars: this.vars,
      stids: this.stids,
      start: toMesoWestTime(this.range.start.minus({ month: subtract })),
      end: toMesoWestTime(this.range.end),
    };
    return Request.get('/stations/statistics', {
      params,
    });
  }

  async loadData() {
    const timeseries = this.getTimeSeries();
    const stats = this.getStats();
    const results = await Promise.all([timeseries, stats]);
    console.log(results);
    return {
      timeseries: results[0].data,
      stats: results[1].data,
    };
  }

}



// WEBPACK FOOTER //
// ./src/models/TimeSeries.js